import { IServicePackagePeriod } from '../../../repositories/billing-tariffs/entities/PublishTerms/ServicePackagePeriod';

export function getPeriodId(period: IServicePackagePeriod): number {
  return period.days;
}
